<template>
    <div>
        <template v-if="hasExtras">
            <table class="w-100 dark mb-4">
                <tr class="fs-small">
                    <th class="extraNameWidth"></th>
                    <th class="pb-2 text-center" style="width: 100px;">Availability</th>
                    <th class="pb-2 text-center" style="width: 120px;">Price/unit</th>
                    <th class="addRemoveWidth" style="width: 200px;"></th>
                </tr>
                <tr class="extraRow border-bottom-light border-top-light" v-for="extra in extrasArrayToAdd" v-if="extra.component.componentType === 0">
                    <td class="darker fs-large pl-2">{{ extra.component.name }} - {{extra.componentPrice.name}}</td>
                    <td class="fs-small text-center">{{ showAvailability(extra) }}</td>
                    <td class="fs-small text-center">{{ formatPrice(extra.componentPrice.grossprice) }} €</td>
                    <td class="d-flex flex-row justify-content-center py-2">
                        <span class="border-light py-2 px-3 radius-normal mx-2 text-center pointer" @click="changeExtraQtd2('remove', extra)"><i class="ico ico-minus dark fs-smaller m-0"></i></span>
                        <input type="number" placeholder="0" min="0" class="text-center fs-larger px-1 py-0 bg-lighter darker" style="width: 2.2rem" :value="extra.quantityToAdd" @input="quantityChanged(extra, $event.target.value)" @focus="extraFocused(extra)">
                        <span class="border-light py-2 px-3 radius-normal mx-2 text-center pointer" @click="changeExtraQtd2('add', extra)"><i class="ico ico-add dark fs-smaller m-0"></i></span>
                    </td>
                </tr>
                <tr class="fs-large">
                    <th class="pt-2 pl-2 extraNameWidth">Total</th>
                    <th class="pt-2 pb-2"></th>
                    <th class="pt-2 pb-2 text-center">{{formatPrice(addedExtrasTotalPrice)}} €</th>
                    <th class="pt-2 addRemoveWidth text-center">{{totalExtras}}</th>
                </tr>
            </table>
        </template>

        <div v-else class="fs-large dark text-center p-2">
            There are no extras to show
        </div>
    </div>
</template>

<script>
import { reservationsMixin } from '@/mixins/reservations'
import { mapGetters, mapActions } from 'vuex'

export default {
    data() {
        return {
            extrasArrayToAdd: null,
            extraItemLoaction: null,
            extrasToAdd: [],
        }
    },
    props: {
        reservation: {
            type: Object
        },
    },
    created() {
        this.extrasArrayToAdd = this.reservation.event.eventComponents;

        this.extrasArrayToAdd.map(extra => {
            this.$set(extra, 'quantityToAdd', 0);
        })
    },
    mixins: [
        reservationsMixin
    ],
    computed: {
        ...mapGetters([
            'getReservationCalculations'
        ]),
        hasExtras() {
            return this.extrasArrayToAdd && this.extrasArrayToAdd.length > 0 && this.extrasArrayToAdd.some(e => e.component.componentType === 0);
        },
        totalExtras(){
            let total = 0;

            for (let extra of this.extrasArrayToAdd) {
                if (extra.quantityToAdd) {
                    total += Number(extra.quantityToAdd);
                }
            }
            
            return total;
        },
        addedExtrasTotalPrice() {
            let total = 0;
            this.extrasArrayToAdd.map(extra => {
                total += extra.quantityToAdd * extra.componentPrice.grossprice
            });

            return total;
        }
    },
    methods: {
        ...mapActions([
            'setReservationCalculations'
        ]),
        showAvailability(extra) {
            if (extra.quantity == 0) {
                return 'unlimited';
            } else {
                return extra.quantityAvailable;
            }
        },
        extraQtd(extra) {
            let total = 0;

            if (this.reservation.bookingComponents) {
                var currentBookingComponent = this.reservation.bookingComponents.find(bookingComponent => {
                    if (bookingComponent.componentPrice) {
                        return bookingComponent.component.id == extra.component.id && bookingComponent.componentPrice.id == extra.componentPrice.id;
                    } else {
                        return bookingComponent.component.id == extra.component.id;
                    }
                })

                if (currentBookingComponent) {
                    total = currentBookingComponent.quantity;
                }
            } else {
                total = extra.quantityBooked;
            }

            return total;
        },
        extraQtd2(extra) {
            return extra.quantity
        },
        changeExtraQtd2(addRemove, extra) {
            if (this.isReservationReadOnly) {
                this.readOnlyShowMessage();

                return false;
            }

            if (addRemove == 'add') {
                // Unlimied
                if (extra.quantity == 0) {
                    extra.originalQuantity = extra.quantity;
                    extra.quantityToAdd++;
                } else {
                    if (extra.quantityAvailable > 0) {
                        extra.originalQuantity = extra.quantity;
                        extra.quantityToAdd++;
                        extra.quantityAvailable--;
                    }
                }
            } else if (addRemove == 'remove') {
                if (extra.quantityToAdd > 0) {
                    extra.quantityToAdd--;
                    
                    // Limited
                    if (extra.originalQuantity != 0) {
                        extra.quantityAvailable++;
                    }
                }
            }
        },
        quantityChanged(extra, newVal) {
            if (extra.quantity === 0) {
                // Unlimited
                extra.quantityToAdd = Number(newVal);
            } else {
                // Limited
                if (Number(newVal) <= extra.quantityAvailable) {
                    extra.quantityToAdd = Number(newVal);
                    extra.quantityAvailable = extra.quantityAvailable - Number(newVal);
                } else {
                    this.$toasted.error('Selected quantity can not be higher than available quantity');
                    this.$set(extra, 'quantityToAdd', null);
                    this.$set(extra, 'quantityToAdd', 0);
                }
            }

            this.setReservationCalculations(this.reservation);
        },
        extraFocused(extra) {
            // Fix to simulate "placeholder" with 0 value
            if (extra.quantityToAdd == 0) {
                extra.quantityToAdd = null;
            }
        },
    }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// AddExtra.vue?ebb8f7f8